// extracted by mini-css-extract-plugin
export default {"popUp":"GridImage_popUp__IEFpB","img":"GridImage_img__7wO90","imgCover":"GridImage_imgCover__-qlz+"};